import { supabase } from './supabase'

// Maglie delle nazionali (dim_national.kit, sql/20261029200000_maglie_nazionali.sql). Servono ai corridori della squadra generica
// NAT (i gruppi "locali" delle gare WT/Pro senza codice squadra): vestono la maglia del loro paese e in lista stanno insieme per paese.
// Una sola lettura per sessione: { [id_national]: { id_national_3, name, kit } }. Se la lettura fallisce si ripiega sulla maglia generica.
export const NAT_TEAM_CODE = 'NAT'

let cache = null
export function loadNationKits() {
  if (!cache) {
    cache = supabase.from('dim_national').select('id_national, id_national_3, name, kit')
      .then(({ data, error }) => {
        if (error) { cache = null; return {} }
        return Object.fromEntries((data ?? []).map(n => [n.id_national, n]))
      })
      .catch(() => { cache = null; return {} })
  }
  return cache
}
